export function buildPropertyCategoryFilterUrl(propertyValue: string) {
  const params = new URLSearchParams();
  params.set("ad_type", "supply");
  params.set("property_type", propertyValue);
  params.set("listing_type", "2");
  params.set("page", "1");

  return `/advertisements-consultants/advertisements-filter/list?${params.toString()}`;
}
